import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
console.log('Response:', response); // Debugging line
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL); // Debugging line
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || 'Erreur de connexion');
      }

      // Enregistre les infos dans localStorage
localStorage.setItem('userId', String(data.user_id));
      localStorage.setItem('isAdmin', data.is_admin === true || data.is_admin === 1 ? 'true' : 'false');
localStorage.setItem('userEmail', formData.email);
        // Redirection selon le rôle
      if (data.is_admin === true || data.is_admin === 1) {
        navigate('/admin');
      } else {
        navigate('/');
      }

    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <label htmlFor="email">Email</label>
      <input
        type="email"
        name="email"
        id="email"
        placeholder="Email"
        value={formData.email}
        onChange={handleChange}
        required
      />

      <label htmlFor="password">Mot de passe</label>
      <input
        type="password"
        name="password"
        id="password"
        placeholder="Mot de passe"
        value={formData.password}
        onChange={handleChange}
        required
      />

      <button type="submit">Se connecter</button>

{error && <p style={{ color: 'red' }} data-testid="login-error">{error}</p>}
    </form>
  );
};

export default LoginPage;
